import React, { useEffect, useRef, useState } from "react";
import SignUpRight from "./common/SignUpRight";
import "./signup.scss";
import logo from "../../Assets/LogoBlack.png";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import axios from "axios";
import ReCAPTCHA from "react-google-recaptcha";
import Cookies from "js-cookie";
import CryptoJS from "crypto-js";
import { toast } from "react-toastify";
// import {getBaseUrl} from '../../env';
import brandIcon from "../../Assets/sign/enterprisebrand.png";
import sellerIcon from "../../Assets/sign/seller2.png";
import neitherIcon from "../../Assets/sign/enterprisebrand.png";
import ParticleBg from "./ParticleBg";
import Timer from "./common/Timer";
import { FaRegCircleXmark, FaRegCircleCheck } from "react-icons/fa6";
import password_false from "../../Assets/password-false.svg";
import password_true from "../../Assets/password-true.svg";
import { GoAlert } from "react-icons/go";
import { IoCheckbox } from "react-icons/io5";
import { createClient } from '@supabase/supabase-js'

// strangth Meter
import { zxcvbnAsync, zxcvbnOptions } from '@zxcvbn-ts/core';
import * as zxcvbnCommonPackage from '@zxcvbn-ts/language-common';
import * as zxcvbnEnPackage from '@zxcvbn-ts/language-en';
import { matcherPwnedFactory } from '@zxcvbn-ts/matcher-pwned';
import Google from "../../Icons/Google";
import Microsoft from "../../Icons/Microsoft";
import Apple from "../../Icons/Apple";
import Facebook from "../../Icons/Facebook";
import Linkedin from "../../Icons/Linkedin";
const options = {
  translations: zxcvbnEnPackage.translations,
  graphs: zxcvbnCommonPackage.adjacencyGraphs,
  dictionary: {
    ...zxcvbnCommonPackage.dictionary,
    ...zxcvbnEnPackage.dictionary,
  },
};
zxcvbnOptions.setOptions(options);

// Create and add the Pwned matcher
const matcherPwned = matcherPwnedFactory(fetch, zxcvbnOptions);
zxcvbnOptions.addMatcher('pwned', matcherPwned);

const strengthLevels = {
  [-1]: { label: 'status', background: '', width: '0', color: 'oklch(55.1% 0.027 264.364)' },
  0: { label: 'Weak', background: 'linear-gradient(90deg, #DC3545 0%, #FF6A00 100%)', width: '20%', color: 'oklch(63.7% 0.237 25.331)' },
  1: { label: 'Normal', background: 'linear-gradient(90deg, oklch(0.705 0.213 47.604) 0%, oklch(0.705 0.213 47.604) 100%)', width: '40%', color: 'oklch(0.705 0.213 47.604)' },
  2: { label: 'Medium', background: 'linear-gradient(90deg, #FFC107 0%, #FF9800 50%, #FFC107 100%)', width: '60%', color: 'oklch(79.5% 0.184 86.047)' },
  3: { label: 'Good', background: 'linear-gradient(90deg, #FFC107 0%, #099359 50%)', width: '80%', color: 'oklch(0.623 0.214 259.815)' },
  4: { label: 'Strong', background: 'linear-gradient(90deg, #DC3545 0%, #FF6A00 10%, #099359 50%)', width: '100%', color: 'oklch(72.3% 0.219 149.579)' },
};


function generateUUID() {
  const specificTimeInIST = new Date();
  const specificTimestampIST = Math.floor(specificTimeInIST.getTime() / 1000);

  const randomAphaNumeric =
    Math.random().toString(36).substring(2, 8) +
    Math.random().toString(36).substring(2, 8);

  const shuffled = (str, num) =>
    (str + num)
      .split("")
      .sort(() => Math.random() - 0.5)
      .join("");

  const UUID = shuffled(randomAphaNumeric, specificTimestampIST);
  Cookies.set("UUID", UUID, { expires: 7 }); // Set cookie to expire in 7 days
  return UUID;
}


const supabase = createClient(
  process.env.REACT_APP_SUPABASE_URL,
  process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY,
  {
    auth: {
      flowType: 'pkce'
    }
  }
)


const SignUpNew = () => {
  const [firstName, setFirstName] = useState("");
  const [firstNameError, setFirstNameError] = useState(null);
  const [lastName, setLastName] = useState("");
  const [lastNameError, setLastNameError] = useState(null);
  const [userEmail, setUserEmail] = useState("");
  const [userEmailError, setUserEmailError] = useState(null);
  const [phone, setPhone] = useState("");
  const [phoneError, setPhoneError] = useState(false);
  const [signUpLoader, setSignUpLoader] = useState(false);
  const [captchaValue, setCaptchValue] = useState("");
  const [accountType, setAccountType] = useState("seller");
  const [website, setWebsite] = useState("");
  const [websiteError, setWebsiteError] = useState(null);
  const [selectedAccountType, setSelectedAccountType] = useState(true);
  const [newPassword, setNewPassword] = useState("");
  const [newPasswordError, setNewPasswordError] = useState(null);
  const [viewPass1, setViewPasss1] = useState(false);
  const [sendOTP, setSendOTP] = useState(false);
  const [isOTP, setIsOTP] = useState(false);
  const [otpValue, setOtpValue] = useState("");
  const [otpError, setOtpError] = useState(null);
  const [sellercode, setSellercode] = useState("");
  const [sellerCodeError, setSellerCodeError] = useState(false);
  const [sellerCodeLoader, setSellerCodeLoader] = useState(false);
  const [sellerInterval, setSellerInterval] = useState(false);
  const [verifiedSeller, setVerifiedSeller] = useState("");
  const [socialLoginInProgress, setSocialLoginInProgress] = useState(false);



  const navigate = useNavigate();
  const [loginType, setLoginType] = useState('manual');

  // Function to reset all login-related states
  const resetLoginStates = (resetProgress = true) => {
    setLoginType('manual');
    setSocialLogin(false);
    setSocialLoggedUser(null);
    setSocialSignupExecuted(false);
    setSignUpLoader(false);
    if (resetProgress) {
      setSocialLoginInProgress(false);
      socialLoginInProgressRef.current = false;
    }
  };

  const checkSellerID = (e) => {
    const sellerCodevalue = e.target.value;
    const pattern = /^A\w{11,13}$/;
    setSellercode(sellerCodevalue);
    setVerifiedSeller("");
    setSellerCodeLoader(false);
    if (sellerCodevalue.trim().length > 0) {
      if (!pattern.test(sellerCodevalue)) {
        setSellerCodeError("Seller ID not Valid");
      } else {
        setSellerCodeError(false);
      }
    } else {
      setSellerCodeError(false);
    }
  };

  const checkOtp = (e) => {
    let valueOtp = e.target.value;

    if (valueOtp.trim().length > 6) {
      valueOtp = valueOtp.slice(0, 6);
    } else if (valueOtp.trim().length < 6) {
      setOtpError("OTP must consist 6 characters");
    } else {
      setOtpError(false);
    }

    setOtpValue(valueOtp);
  };

  const checkWebsite = (e) => {
    const url = e.target.value;
    setWebsite(url);
    const urlRegex = /^(?:(?:www\.)?)[\w.-]+\.\w{2,}(?:\/.*)?$/i;
    const isValidUrl = urlRegex.test(url);
    setWebsiteError(isValidUrl ? false : "Website URL is not valid");
  };

  const checkFirstName = (e) => {
    const firstNameValue = e.target.value;
    setFirstName(firstNameValue);
    if (firstNameValue.trim().length < 3) {
      setFirstNameError("Type at least 3 characters");
    } else {
      setFirstNameError(false);
    }
  };

  const checkLastName = (e) => {
    const lastNameValue = e.target.value;
    setLastName(lastNameValue);
    if (lastNameValue.trim().length < 3) {
      setLastNameError("Type at least 3 characters");
    } else {
      setLastNameError(false);
    }
  };

  const checkEmail = (e) => {
    setIsOTP(false);
    setSendOTP(false);
    let emailValue = e.target.value.trim();

    emailValue = emailValue.replace(/\s+/g, '');

    const emailReg = /^[\w+.-]+@([\w-]+\.)+[a-zA-Z]{2,7}$/;
    const hasPlusBeforeAt =
      emailValue.includes("+") &&
      emailValue.indexOf("+") < emailValue.indexOf("@");
    setUserEmail(emailValue);

    if (!emailReg.test(emailValue)) {
      setUserEmailError("Please enter a valid email address");
    } else if (hasPlusBeforeAt) {
      setUserEmailError("Aliases are not allowed");
      toast.error("Aliases are not allowed");
    } else {
      setUserEmailError(false);
      generateUUID();
    }
  };

  const [isResized, setIsResized] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setIsResized(width >= 992);
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);



  const [strength, setStrength] = useState({
    score: -1,
    hasChar: false,
    hasUppercase: false,
    hasLowercase: false,
    hasNumber: false,
    hasSpecialChar: false,
    isLoading: false,
    isPwned: true,
  });
  const [passwordTyping, setPasswordTyping] = useState(false);
  const debounceTimer = useRef(null);
  const [checkPasswordInCorrect, setCheckPasswordInCorrect] = useState(false);

  const checkNewPassword = (e) => {
    const passwordValue = e.target.value;
    setNewPassword(passwordValue);
    if (passwordValue.trim().length === 0) {
      setNewPasswordError("Please enter a password");
    } else {
      setNewPasswordError(false);
    }
  };

  useEffect(() => {
    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }

    if (newPassword.length === 0) {
      setCheckPasswordInCorrect(false);
      setNewPasswordError(null);
      setStrength({
        score: -1,
        hasChar: false,
        hasUppercase: false,
        hasLowercase: false,
        hasNumber: false,
        hasSpecialChar: false,
        isLoading: false
      });
      setPasswordTyping(false);
      return;
    }

    setPasswordTyping(true);


    // --- UI Rules (same as before) ---
    const hasChar = newPassword.length >= 12;
    const hasUppercase = /[A-Z]/.test(newPassword);
    const hasLowercase = /[a-z]/.test(newPassword);
    const hasUpperAndLower = hasUppercase && hasLowercase;
    const hasNumber = /[0-9]/.test(newPassword);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(newPassword);
    let rulesMetCount = 0;
    if (hasChar) rulesMetCount++;
    if (hasUpperAndLower) rulesMetCount++;
    if (hasNumber) rulesMetCount++;
    if (hasSpecialChar) rulesMetCount++;
    setCheckPasswordInCorrect(!(hasChar && hasUpperAndLower && hasNumber && hasSpecialChar));

    setStrength((prev) => ({
      ...prev,
      hasChar,
      hasUppercase,
      hasLowercase,
      hasNumber,
      hasSpecialChar,
    }));
    if (newPassword.length < 5) {
      setStrength((prev) => ({
        ...prev,
        score: 0,
        isPwned: true,
        isLoading: false,
      }));
      setTimeout(() => {
        setPasswordTyping(false);
      }, 3500);
      return;
    }

    setStrength((prev) => ({
      ...prev,
      isLoading: true,
    }));

    // --- Debounce and async zxcvbn check ---
    debounceTimer.current = setTimeout(() => {
      const checkStrength = async () => {
        try {
          // --- zxcvbn check (now async) ---
          const result = await zxcvbnAsync(newPassword);
          const zxcvbnScore = result.score;
          const isPwned = result.sequence.some((seq) => seq.pattern === 'pwned');

          // --- Final Score (same as before) ---
          const finalScore = Math.min(rulesMetCount, zxcvbnScore);

          setStrength((prev) => ({
            ...prev,
            score: finalScore,
            isLoading: false, // Done loading
            isPwned,
          }));

        } catch (error) {
          setStrength((prev) => ({
            ...prev,
            isPwned: true,
            isLoading: false, // Stop loading on error
          }));
        } finally {
          // This is for the tooltip UI
          setTimeout(() => {
            setPasswordTyping(false);
          }, 3500);
        }
      };
      checkStrength();
    }, 1000); // 1000ms debounce

    return () => {
      if (debounceTimer.current) {
        clearTimeout(debounceTimer.current);
      }
    };
  }, [newPassword]);

  const checkPhone = (e) => {
    let phoneValue = e.target.value;
    setPhone(phoneValue);

    if (phoneValue.trim().length > 0 && phoneValue.length != 10) {
      setPhoneError("Wrong Phone Number type");
    } else {
      setPhoneError(false);
    }
  };

  const handleRecaptchaChange = (value) => {
    setCaptchValue(value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Reset all login states and set to manual login
    resetLoginStates();

    if (accountType === "brand") {
      if (firstNameError !== false) {
        setFirstNameError("Please fill this field");
      } else if (userEmailError !== false) {
        setUserEmailError("Please fill this field");
      } else if (newPasswordError !== false) {
        setNewPasswordError("Please fill this field");
      } else if (phoneError !== false) {
        setPhoneError("Invalid Phone Number");
      } else if (website.trim().length > 0 && websiteError !== false) {
        setWebsiteError("Incorrect website name format");
      } else if (checkPasswordInCorrect) {
        toast.error("Password needs 12+ chars, with uppercase & lowercase letters, a number, and a symbol.");
        return;
      } else {
        if (isOTP === false) {
          checkPaymentStatus();
        } else {
          window.grecaptcha.execute();
        }
      }
    } else if (accountType === "seller") {
      // console.log(verifiedSeller.trim().length, "223");
      // console.log(sellerCodeError !== false);
      if (firstNameError !== false) {
        setFirstNameError("Please fill this field");
      } else if (userEmailError !== false) {
        setUserEmailError("Please enter a valid email address");
      } else if (newPasswordError !== false) {
        setNewPasswordError("Please fill this field");
      } else if (sellerCodeError !== false) {
        setSellerCodeError("Invalid Seller ID");
      } else if (verifiedSeller.trim().length > 0) {
        // setSellerCodeError("Verify the seller ID to proceed");
        toast.error("Verify the Seller ID to proceed");
        // setSellerCodeError("");
      } else if (phoneError !== false) {
        setPhoneError("Invalid Phone Number");
      } else if (checkPasswordInCorrect) {
        toast.error("Password needs 12+ chars, with uppercase & lowercase letters, a number, and a symbol.");
        return;
      } else {
        if (isOTP === false) {
          checkPaymentStatus();
        } else {
          window.grecaptcha.execute();
        }
      }
    } else {
      if (firstNameError !== false) {
        setFirstNameError("Please fill this field");
      } else if (lastNameError !== false) {
        setLastNameError("Please fill this field");
      } else if (userEmailError !== false) {
        setUserEmailError("Please enter a valid email address");
      } else if (newPasswordError !== false) {
        setNewPasswordError("Please fill this field");
      } else if (phoneError !== false) {
        setPhoneError("Invalid Phone Number");
      } else if (checkPasswordInCorrect) {
        toast.error("Password needs 12+ chars, with uppercase & lowercase letters, a number, and a symbol.");
        return;
      } else {
        if (isOTP === false) {
          checkPaymentStatus();
        } else {
          window.grecaptcha.execute();
        }
      }
    }
  };

  const OTPsubmit = (e) => {
    e.preventDefault();
    if (accountType !== "neither") {
      if (firstNameError !== false) {
        setFirstNameError("Please fill this field");
      } else if (userEmailError !== false) {
        setUserEmailError("Please enter a valid email address");
      } else if (newPasswordError !== false) {
        setNewPasswordError("Please fill this field");
      } else if (phoneError !== false) {
        setPhoneError("Invalid Phonee Number");
      } else if (otpError !== false) {
        setOtpError("Incorrect OTP");
      } else {
        if (captchaValue?.length > 0) {
          signUpFirstApi();
        } else {
          window.grecaptcha.execute();
        }
      }
    } else {
      if (firstNameError !== false) {
        setFirstNameError("Please fill this field");
      } else if (lastNameError !== false) {
        setLastNameError("Please fill this field");
      } else if (userEmailError !== false) {
        setUserEmailError("Please enter a valid email address");
      } else if (newPasswordError !== false) {
        setNewPasswordError("Please fill this field");
      } else if (phoneError !== false) {
        setPhoneError("Invalid Phone Number");
      } else if (otpError !== false) {
        setOtpError("Incorrect OTP");
      } else {
        if (captchaValue?.length > 0) {
          signUpFirstApi();
        } else {
          window.grecaptcha.execute();
        }
      }
    }
  };

  const signUpFirstApi = async () => {
    setSignUpLoader(true);
    const sessionID = Cookies.get("UUID");
    const BrandformData = {
      brand_name: firstName,
      email: userEmail,
      phone_number: phone,
      uuid: sessionID,
      captcha: captchaValue,
      account_type: accountType,
      is_otp_sent: isOTP,
      ...(isOTP ? { otp: otpValue } : {}),
      brand_site: website,
      password: newPassword,
    };
    const SellerformData = {
      bussiness_name: firstName,
      email: userEmail,
      phone_number: phone,
      uuid: sessionID,
      captcha: captchaValue,
      seller_id: sellercode,
      seller_name: verifiedSeller,
      account_type: accountType,
      is_otp_sent: isOTP,
      ...(isOTP ? { otp: otpValue } : {}),
      bussiness_site: website,
      password: newPassword,
    };
    const OtherformData = {
      first_name: firstName,
      last_name: lastName,
      email: userEmail,
      phone_number: phone,
      uuid: sessionID,
      captcha: captchaValue,
      account_type: accountType,
      is_otp_sent: isOTP,
      ...(isOTP ? { otp: otpValue } : {}),
      password: newPassword,
    };

    let formData;

    if (accountType === "brand") {
      formData = BrandformData;
    } else if (accountType === "seller") {
      formData = SellerformData;
    } else {
      formData = OtherformData;
    }
    formData.login_type = loginType;
    if (loginType === 'social') {
      formData.social_uid = socialLoggedUser?.id;
      formData.social_provider_email = socialLoggedUser?.email;
      formData.social_provider_uid = socialLoggedUser?.id;
      formData.social_provider_name = socialLoggedUser?.app_metadata?.provider;
      formData.social_provider_avatar = socialLoggedUser?.user_metadata?.picture || "";
    }
    const api = axios.create({
      baseURL: process.env.REACT_APP_BACKEND_URL,
    });
    // return;
    await api
      .post(`/api/signup`, formData)
      .then(async (response) => {
        const secretKey = "Klizo";
        const encrypteStep = CryptoJS.AES.encrypt(
          "StepThreeDone",
          secretKey
        ).toString();
        Cookies.set("step", encrypteStep, { expires: 7 });
        Cookies.set("first_name", firstName, { expires: 7 });

        setTimeout(() => {
          window.location.reload();
        }, 100);
        setSignUpLoader(false);
      })
      .catch((error) => {
        setSignUpLoader(false);
        toast.error(error?.response?.data?.message);
      });
  };

  const checkPaymentStatus = () => {
    const api = axios.create({
      baseURL: process.env.REACT_APP_BACKEND_URL,
    });

    const mailData = {
      email: userEmail,
    };
    mailData.login_type = loginType;
    setSignUpLoader(true);
    api
      .post(`/api/check-payment-status`, mailData)
      .then((response) => {
        if (response?.data?.payment_status === true) {
          toast.error("This email id is already registered");
        } else if (
          response?.data?.payment_status === false &&
          response?.data?.otp_sent === true
        ) {
          toast.success(response?.data?.message);
          setOtpValue("");
          setSendOTP(true);
          setIsOTP(true);
        } else if (
          response?.data?.payment_status === false &&
          response?.data?.otp_sent === false
        ) {
          if (captchaValue !== null && captchaValue.length > 0) {
            signUpFirstApi();
            console.log("capcthaValue", captchaValue);
          } else {
            window.grecaptcha.execute();
            console.log("capcthaValue", captchaValue);
          }
        } else {
          toast.error("Something went wrong,try again later.");
        }
        setSignUpLoader(false);
      })
      .catch((error) => {
        setSignUpLoader(false);
        toast.error(error?.response?.data?.message);
        if (error?.response?.data?.otp_already_sent) {
          setOtpValue("");
          setSendOTP(true);
          setIsOTP(true);
        }
        // console.log("ccc", error?.response?.data?.otp_already_sent);
        // console.log("ccc", otpValue);
      });
    console.log("captcha value", captchaValue);
  };

  useEffect(() => {
    const paymentPage = Cookies.get("payment_page");
    if (paymentPage === "failure") {
      Cookies.remove("payment_page");
      Cookies.remove("step");
      Cookies.remove("uuid");
      navigate("/sign-up");
    }
    if (captchaValue?.length > 0 && !sellerCodeLoader) {
      if (loginType === 'social' && IsSocialLogin && !socialSignupExecuted) {
        setSocialSignupExecuted(true); // Set flag before calling API to prevent duplicate calls
        // Check payment status first, then proceed with signup
        checkSocialPaymentStatus(socialLoggedUser?.email);
      } else if (loginType !== 'social') {
        signUpFirstApi();
      }
    } else if (captchaValue?.length > 0 && sellerCodeLoader) {
      sellerVerifyAPI();
    }
    // }, [captchaValue]);
  }, [captchaValue]);

  const clickAccountType = () => {
    if (accountType.length > 0) {
      const label = document.querySelector(
        `label[for=${accountType}]`
      ).textContent;
      setSelectedAccountType(label);
    } else {
      setSelectedAccountType(false);
    }
    setFirstName("");
    setLastName("");
    setUserEmail("");
    setNewPassword("");
    setWebsite("");
    setPhone("");
    setOtpValue("");
    setSellercode("");
    setFirstNameError(null);
    setLastNameError(null);
    setUserEmailError(null);
    setNewPasswordError(null);
    setWebsiteError(null);
    setPhoneError(null);
    setPhoneError(null);
    setOtpError(null);
    setSellerCodeError(null);
    setSellerCodeLoader(false);
    setVerifiedSeller("");
  };
  const changeAccountType = () => {
    setSelectedAccountType(false);
  };
  const sellerverification = () => {
    setSellerCodeLoader(true);
    if (captchaValue?.length > 0) {
      // setSellerCodeLoader(false);
      sellerVerifyAPI();
    } else {
      window.grecaptcha.execute();
    }
  };
  const sellerVerifyAPI = () => {
    // setSellerCodeLoader(true);
    const api = axios.create({
      baseURL: process.env.REACT_APP_BACKEND_URL,
    });
    const sessionID = Cookies.get("UUID");
    const sellerData = {
      uuid: sessionID,
      seller_id: sellercode,
      captcha: captchaValue,
    };
    // setTimeout(() => {
    api
      .post(`/api/seller-id-verification`, sellerData)
      .then((response) => {
        // console.log("483", response);
        // console.log("489", response?.data?.data);
        toast.success(response?.data?.message);
        setSellerCodeError("");
        setVerifiedSeller(response?.data?.data);
        setSellerCodeError(false);
        setSellerCodeLoader(false);
        setSellerInterval(true);
        setTimeout(() => {
          setSellerInterval(false);
        }, 10000);
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message);
        setSellerCodeLoader(false);
        setSellerInterval(true);
        if (error?.response?.data?.status == false) {
          setVerifiedSeller("");
          setSellerCodeError(error?.response?.data?.message);
        }
        setTimeout(() => {
          setSellerInterval(false);
        }, 10000);
      });
    // }, 40000);
  };
  const SocialIcons = [
    {
      icon_image: Google,
      provider: 'google',
      disabled: false
    },
    // {
    //   icon_image: Microsoft,
    //   provider: 'azure',
    //   disabled: false
    // },
    // {
    //   icon_image: Apple,
    //   provider: 'linkedin_oidc',
    //   disabled: true

    // },
    {
      icon_image: Linkedin,
      provider: 'linkedin_oidc',
      disabled: false
    }

  ];


  const [IsSocialLogin, setSocialLogin] = useState(false);
  const [socialLoggedUser, setSocialLoggedUser] = useState(null);
  const [socialSignupExecuted, setSocialSignupExecuted] = useState(false);

  // Use a ref to track social login in progress for immediate access in event handlers
  const socialLoginInProgressRef = useRef(false);
  
  // Use a ref to store the auth listener subscription so we can clean it up
  const authListenerRef = useRef(null);

  const handleSocialLogin = async (provider) => {
    try {
      // Clean up any existing auth listener from previous attempts
      if (authListenerRef.current?.subscription) {
        authListenerRef.current.subscription.unsubscribe();
        authListenerRef.current = null;
      }

      // Set social login in progress immediately to prevent premature resets
      setSocialLoginInProgress(true);
      socialLoginInProgressRef.current = true;
      setLoginType('social');

      // Reset other login states but keep progress indicator
      setSocialLogin(false);
      setSocialLoggedUser(null);
      setSocialSignupExecuted(false); // Reset this flag for fresh attempt
      setSignUpLoader(false);

      // Explicitly reset social-specific states for fresh start
      setSocialLogin(false);
      setSocialLoggedUser(null);
      setSocialSignupExecuted(false);

      // Sign out from any existing Supabase session to ensure fresh start
      await supabase.auth.signOut();

      // Generate fresh UUID for this login attempt
      generateUUID();

      // Reset captcha to ensure fresh reCAPTCHA execution
      setCaptchValue('');

      // console.log('All states reset for fresh social login with provider:', provider);

      // Store current session state before starting social login
      const { data: { session: initialSession } } = await supabase.auth.getSession();
      // console.log('Initial session before social login:', !!initialSession);

      // Flag to track if SIGNED_IN event occurred - reset for each provider
      let authSuccess = false;
      let authCompleted = false;

      // Reset social signup flag for fresh attempt with this provider
      setSocialSignupExecuted(false);

      // Reset captcha for fresh reCAPTCHA execution
      setCaptchValue('');

      setSignUpLoader(true);

      // Track when social login started to avoid premature resets
      const socialLoginStartTime = Date.now();

      // Declare variables for cleanup
      let resetTimeout = null;
      let handleWindowFocus = null;
      let handleWindowBlur = null;
      let fallbackTimeout = null;

      // Set up a timeout to reset states if popup doesn't complete within 5 minutes
      resetTimeout = setTimeout(() => {
        // eslint-disable-next-line no-undef
        if (resetTimeout) clearTimeout(resetTimeout);
        // eslint-disable-next-line no-undef
        if (fallbackTimeout) clearTimeout(fallbackTimeout);
        // eslint-disable-next-line no-undef
        if (handleWindowFocus) window.removeEventListener('focus', handleWindowFocus);
        // eslint-disable-next-line no-undef
        if (handleWindowBlur) window.removeEventListener('blur', handleWindowBlur);
        resetLoginStates();
      }, 300000); // 5 minutes

      // Also set up a shorter timeout as fallback in case focus detection fails
      fallbackTimeout = setTimeout(() => {
        console.log('Social login fallback timeout - checking if we should reset');
        const timeSinceStart = Date.now() - socialLoginStartTime;
        const socialLoginStillInProgress = socialLoginInProgressRef.current;
        if (timeSinceStart > 3000 && socialLoginStillInProgress && !authSuccess && !authCompleted) {
          console.log('Fallback: No auth events detected after sufficient time, resetting states');
          // eslint-disable-next-line no-undef
          if (resetTimeout) clearTimeout(resetTimeout);
          // eslint-disable-next-line no-undef
          clearTimeout(fallbackTimeout);
          // eslint-disable-next-line no-undef
          if (handleWindowFocus) window.removeEventListener('focus', handleWindowFocus);
          resetLoginStates();
        } else {
          console.log('Fallback: Not resetting - timeSinceStart:', timeSinceStart, 'socialLoginInProgress (ref):', socialLoginStillInProgress);
        }
      }, 10000); // 10 seconds

      // Track if popup has stolen focus
      let popupHasFocus = false;

      // Listen for window blur to know when popup takes focus
      handleWindowBlur = () => {
        popupHasFocus = true;
        window.removeEventListener('blur', handleWindowBlur);
      };

      // Listen for window focus to detect when user returns from popup
      handleWindowFocus = () => {
        const timeSinceStart = Date.now() - socialLoginStartTime;
        const socialLoginStillInProgress = socialLoginInProgressRef.current;
        console.log('Window focused - checking if social login should be reset');
        console.log('Time since start:', timeSinceStart, 'ms, popupHasFocus:', popupHasFocus);
        console.log('Current state: authSuccess:', authSuccess, 'authCompleted:', authCompleted, 'socialLoginInProgress (state):', socialLoginInProgress, 'socialLoginInProgress (ref):', socialLoginStillInProgress);

        // Only reset if popup had focus and we're still showing social login progress
        if (popupHasFocus && timeSinceStart > 1000 && socialLoginStillInProgress && !authSuccess && !authCompleted) {
          console.log('Popup had focus and social login still in progress (via ref) - user likely closed popup, resetting states');
          // eslint-disable-next-line no-undef
          if (resetTimeout) clearTimeout(resetTimeout);
          // eslint-disable-next-line no-undef
          clearTimeout(fallbackTimeout);
          // eslint-disable-next-line no-undef
          window.removeEventListener('focus', handleWindowFocus);
          window.removeEventListener('blur', handleWindowBlur);
          resetLoginStates();
        } else {
          console.log('Not resetting: popupHasFocus:', popupHasFocus, 'timeSinceStart:', timeSinceStart, 'socialLoginInProgress (ref):', socialLoginStillInProgress);
        }
      };

      window.addEventListener('blur', handleWindowBlur);
      window.addEventListener('focus', handleWindowFocus);

      const response = await supabase.auth.signInWithOAuth({
        provider: provider,
        options: {
          redirectTo: `${window.location.origin}/auth/callback`,
          // redirectTo: `https://dev.nformed.com/auth/callback`,
          skipBrowserRedirect: true,
          queryParams: {
            access_type: 'offline',
            prompt: 'consent',
          }
          // For LinkedIn specific scopes
          // scopes: provider === 'linkedin' ? 'r_liteprofile r_emailaddress' : undefined
        }
      });

      const { data, error } = response;

      if (error) throw error;

      const left = (window.screen.width - 600) / 2;
      const top = (window.screen.height - 700) / 2;

      const popupWindow = window.open(
        data?.url,
        'Nformed Social Login :: ' + provider,
        `width=600,height=700,,left=${left},top=${top},scrollbars=yes,resizable=yes`
      );

      if (!popupWindow) {
        toast.error('Please allow popups for this website');
        setSignUpLoader(false);
        setSocialLoginInProgress(false);
        return;
      }

      // Check if popup is already closed (user closed it immediately)
      if (popupWindow.closed) {
        toast.error('Popup was closed immediately');
        setSignUpLoader(false);
        setSocialLoginInProgress(false);
        return;
      }

      popupWindow.focus();



      // Note: We rely on window focus detection and the resetTimeout for cleanup

      // Listen for auth state changes
      const { data: authListener } = supabase.auth.onAuthStateChange(async (event, session) => {

        if (event === 'SIGNED_IN' && session) {
          console.log('SIGNED_IN event detected - authentication successful');
          
          // Check if we already processed this user (prevent duplicate processing)
          if (authCompleted) {
            console.log('Already processed this SIGNED_IN event, skipping');
            return;
          }
          
          authSuccess = true;
          authCompleted = true;

          // Clear timeouts and event listeners since authentication succeeded
          // eslint-disable-next-line no-undef
          if (resetTimeout) clearTimeout(resetTimeout);
          // eslint-disable-next-line no-undef
          if (handleWindowFocus) window.removeEventListener('focus', handleWindowFocus);
          // eslint-disable-next-line no-undef
          if (handleWindowBlur) window.removeEventListener('blur', handleWindowBlur);
          // eslint-disable-next-line no-undef
          clearTimeout(fallbackTimeout);
          // Don't reset loading states since auth succeeded

          setSocialLogin(true);
          setSocialLoggedUser(session?.user);
          setLoginType('social');

          // Get user data from social login
         /* const userName = session?.user?.user_metadata?.name || session?.user?.user_metadata?.full_name || "";
          const userEmailData = session?.user?.email || "";
          const userPhone = session?.user?.phone || "";*/

          // Close the popup window
          if (popupWindow && !popupWindow.closed) {
            popupWindow.close();
          }

          // Unsubscribe from auth listener
          if (authListener && authListener.subscription) {
            authListener.subscription.unsubscribe();
            authListenerRef.current = null; // Clear the ref
          }

          // Directly call signup API with social login data
          await handleSocialSignup(session?.user);

        } else if (event === 'INITIAL_SESSION' && !session) {
          // This is just the initial state check, not an actual event
          // console.log('Initial session check - no session found');
        }
      });
      
      // Store the listener in ref for cleanup
      authListenerRef.current = authListener;

    } catch (error) {
      toast.error(error.message);
      // eslint-disable-next-line no-undef
      if (resetTimeout) clearTimeout(resetTimeout);
      // eslint-disable-next-line no-undef
      clearTimeout(fallbackTimeout);
      // eslint-disable-next-line no-undef
      if (handleWindowFocus) window.removeEventListener('focus', handleWindowFocus);
      // eslint-disable-next-line no-undef
      if (handleWindowBlur) window.removeEventListener('blur', handleWindowBlur);
      
      // Clean up auth listener on error
      if (authListenerRef.current?.subscription) {
        authListenerRef.current.subscription.unsubscribe();
        authListenerRef.current = null;
      }
      
      resetLoginStates();
    }
  }

  const handleSocialSignup = async (user) => {
    try {

      // Generate UUID for social login
      generateUUID();

      // Clear any existing captcha value to ensure fresh reCAPTCHA execution triggers useEffect
      setCaptchValue('');

      // Store social user data first
      setSocialLoggedUser(user);
      setLoginType('social');

      // Set a flag to indicate we're doing social signup BEFORE reCAPTCHA
      setSocialLogin(true);
      setSocialSignupExecuted(false); // Ensure this is false for useEffect

      console.log('Social login states set, executing reCAPTCHA');

      // Small delay to ensure state updates, then execute reCAPTCHA
      setTimeout(() => {
        window.grecaptcha.execute();
      }, 100);

      // The payment status check will be handled in the useEffect when captcha is received

    } catch (error) {
      resetLoginStates();
      toast.error('Signup failed. Please try again.');
    }
  }

  const checkSocialPaymentStatus = async (email) => {
    try {
      // Ensure loading states are active during API call
      setSignUpLoader(true);
      setSocialLoginInProgress(true);

      const api = axios.create({
        baseURL: process.env.REACT_APP_BACKEND_URL,
      });

      const paymentData = {
        email: email,
        // captcha: captchaValue, // Include captcha in the payment check API
      };

      const response = await api.post(`/api/check-payment-status-for-social-login`, paymentData);

      if (response?.data?.status === true) {
        if (response?.data?.payment_status === true) {
          // User exists with complete payment - redirect to dashboard
          toast.error('This email id is already registered');
          setSocialSignupExecuted(false); // Reset flag to allow new attempts
          socialLoginInProgressRef.current = false; // Reset ref as well
          setCaptchValue(''); // Clear captcha for fresh attempt
          setSignUpLoader(false);
          setSocialLoginInProgress(false);
        } else {
          // User exists with incomplete payment or no user found - continue to signup
          proceedWithSocialSignup();
          // Loading states remain active during signup process
        }
      } else {
        // Subscription expired or other error
        toast.error(response?.data?.message || 'Please contact support.');
        setSocialSignupExecuted(false); // Reset flag to allow new attempts
        socialLoginInProgressRef.current = false; // Reset ref as well
        setCaptchValue(''); // Clear captcha for fresh attempt
        setSignUpLoader(false);
        setSocialLoginInProgress(false);
      }
    } catch (error) {
      // If API fails, reset states and show error
      setSocialSignupExecuted(false); // Reset flag to allow new attempts
      socialLoginInProgressRef.current = false; // Reset ref as well
      setCaptchValue(''); // Clear captcha for fresh attempt
      resetLoginStates();
      toast.error(error?.response?.data?.message || 'Please contact support.');
    }
  }

 /* const proceedWithSocialSignup = () => {
    // Execute the actual social signup with the existing captcha
    executeSocialSignup(captchaValue);
  }*/

  const proceedWithSocialSignup = async () => {
    try {
      const sessionID = Cookies.get("UUID");

      // Extract name information from social login
      const fullName = socialLoggedUser?.user_metadata?.name || socialLoggedUser?.user_metadata?.full_name || "";
      // const nameParts = fullName.trim().split(' ');
      // const firstName = nameParts[0] || "";
      // const lastName = nameParts.length > 1 ? nameParts.slice(1).join(' ') : "User"; // Use "User" as default if no last name

      // Create form data for social signup
      const socialFormData = {
        bussiness_name: fullName,
        email: socialLoggedUser?.email || "",
        phone_number: socialLoggedUser?.phone || "",
        uuid: sessionID,
        captcha: captchaValue,
        seller_id: "", // Empty for social login
        seller_name: "", // Empty for social login
        account_type: "seller",
        is_otp_sent: false,
        bussiness_site: "", // Empty for social login
        password: "", // No password needed for social login
        login_type: 'social',
        social_uid: socialLoggedUser?.id,
        social_provider_email: socialLoggedUser?.email,
        social_provider_uid: socialLoggedUser?.id,
        social_provider_name: socialLoggedUser?.app_metadata?.provider,
        social_provider_avatar: socialLoggedUser?.user_metadata?.picture || "",
      };

      const api = axios.create({
        baseURL: process.env.REACT_APP_BACKEND_URL,
      });

      await api
        .post(`/api/signup`, socialFormData)
        .then(async (response) => {
          const secretKey = "Klizo";
          const encrypteStep = CryptoJS.AES.encrypt(
            "StepThreeDone",
            secretKey
          ).toString();
          Cookies.set("step", encrypteStep, { expires: 7 });
          Cookies.set("first_name", fullName, { expires: 7 });

          toast.success('Account created successfully!');

          // Force page reload to ensure RedirectComponent works properly
          setTimeout(() => {
            window.location.reload();
          }, 100);

          setSignUpLoader(false);
          setSocialLoginInProgress(false); // Reset social login progress on success
        })
        .catch((error) => {
          setSocialSignupExecuted(false); // Reset flag to allow new attempts
          socialLoginInProgressRef.current = false; // Reset ref as well
          setCaptchValue(''); // Clear captcha for fresh attempt
          resetLoginStates();
          toast.error(error?.response?.data?.message || 'Signup failed. Please try again.');
        });

    } catch (error) {
      setSignUpLoader(false);
      setSocialLoginInProgress(false); // Reset social login progress on error
      socialLoginInProgressRef.current = false; // Reset ref as well
      setSocialSignupExecuted(false); // Reset flag to allow new attempts
      setCaptchValue(''); // Clear captcha for fresh attempt
      toast.error('Signup failed. Please try again.');
    }
  }



  return (
    <div className="signUpFlow py-5">
      <ParticleBg />
      <div className="container position-relative pt-5">
        <div className="row g-4 g-xl-5 align-items-center justify-content-center">
          {/* <div className="col-12 mt-lg-0">
            <div className="row justify-content-center">

              <div className="col-lg-6 col-xl-7 col-xxl-7 ms-auto">
                <div className="offer_bar sign_up">
                    <h5>Get $50 off at sign-up, use code <span className="shadow">Nformed50</span></h5>
                </div>
              </div>

            </div>
          </div> */}
          <div className="col-lg-6 col-xxl-5 col-xl-5">
            <div className="">
              <img src={logo} alt="" className="img-fluid spLogo" />
            </div>
            <div className="signUpLeft">
              <h5>Create Account</h5>
              <p className="mb-3">
                You're just a few clicks away from your next winning Amazon
                product. We're excited for you!
              </p>
              <div>
                <p className="mb-3" style={{ fontSize: '14px' }}>Sign Up with</p>
                <div className="d-flex flex-nowrap gap-3">
                  {SocialIcons.map((data, index) => (
                    <button
                      type="button"
                      disabled={data.disabled || socialLoginInProgress}
                      onClick={() => handleSocialLogin(data.provider)}
                      className={`w-100 social-login-btn ${(data.disabled || socialLoginInProgress) ? "disabled cursor-disabled opacity-25" : "cursor-pointer"}`}
                      key={index}
                    >
                      <div className="d-flex align-items-center justify-content-center">
                        <data.icon_image />
                        {socialLoginInProgress && (
                          <div className="ms-2">
                            <i className="bi bi-arrow-repeat spin" style={{ fontSize: '14px' }}></i>
                          </div>
                        )}
                      </div>
                    </button>
                  ))}
                </div>
                <div className='position-relative'>
                  <span className="or-cls">Or</span>
                  <hr style={{ borderTopColor: 'rgba(239, 239, 239, 1)', opacity: '1', margin: '2.5rem 0' }} />
                </div>
              </div>
              <Form onSubmit={handleSubmit}>
                {!selectedAccountType && (
                  <div className="row g-2 mb-3 will_hide">
                    <div className="col-12">
                      <h2 className="fw-bold fs-2 mt-3">You are</h2>
                    </div>
                    <div className="col-12">
                      <Form.Check>
                        <Form.Check.Input
                          type={"radio"}
                          id={`brand`}
                          name="accountType"
                          defaultChecked={accountType === "brand"}
                          onChange={() => setAccountType("brand")}
                        />
                        <Form.Check.Label
                          htmlFor="brand"
                        // onMouseOver={() => setAccountType("brand")}
                        >
                          <img
                            src={brandIcon}
                            className="img-fluid me-3"
                            alt="Brand/Organization"
                          />
                          Brand/Organization
                        </Form.Check.Label>
                      </Form.Check>
                    </div>
                    <div className="col-12">
                      <Form.Check>
                        <Form.Check.Input
                          type={"radio"}
                          id={`seller`}
                          name="accountType"
                          defaultChecked={accountType === "seller"}
                          onChange={() => setAccountType("seller")}
                        />
                        <Form.Check.Label htmlFor="seller">
                          <img
                            src={sellerIcon}
                            className="img-fluid me-3"
                            alt="Seller/Independent manufacturer"
                          />
                          Seller/Independent Manufacturer
                        </Form.Check.Label>
                      </Form.Check>
                    </div>
                    <div className="col-12">
                      <Form.Check>
                        <Form.Check.Input
                          type={"radio"}
                          id={`neither`}
                          name="accountType"
                          defaultChecked={accountType === "neither"}
                          onChange={() => setAccountType("neither")}
                        />
                        <Form.Check.Label htmlFor="neither">
                          <img
                            src={neitherIcon}
                            className="img-fluid me-3"
                            alt="neither"
                          />
                          I'm an Enthusiast
                        </Form.Check.Label>
                      </Form.Check>
                    </div>
                    <div className="col-12">
                      <button
                        className="btn btn-main2  w-100 mt-4"
                        type="buton"
                        disabled={accountType.length > 0 ? false : true}
                        onClick={clickAccountType}
                      >
                        Continue
                      </button>
                    </div>
                  </div>
                )}

                {accountType.length > 0 && selectedAccountType && (
                  <>
                    {/* <div className="selectedAccount">
                      <p>You are:</p>
                      <div className="row g-3 pt-1">
                        <div className="col-auto me-auto">
                          <h6 className="text-capitalize">
                            {accountType.length > 0 ? selectedAccountType : ""}
                          </h6>
                        </div>
                        <div className="col-auto">
                          <a
                            type="button"
                            onClick={changeAccountType}
                            className="btn p-0 border-0 text-primary"
                            style={{ textDecoration: "underline" }}
                          >
                            Change
                          </a>
                        </div>
                      </div>
                    </div> */}
                    <Form.Group className="mb-4" controlId="firstName">
                      <Form.Label>
                        {accountType === "brand" && "Brand/Organization"}
                        {accountType === "seller" && "Name"}
                        {accountType === "neither" && "First Name"}
                        <span className="text-danger ms-1">*</span>
                      </Form.Label>
                      <div className="position-relative custom-field">
                        <i className="bi bi-person-fill position-absolute start-0 h-100 pe-1 d-flex align-items-center fs-5"></i>
                        <Form.Control
                          className={firstNameError ? "error ps-4" : "ps-4"}
                          type="text"
                          placeholder={`${accountType === "brand"
                            ? "Brand/Organization"
                            : accountType === "seller"
                              ? "First and last name"
                              : accountType === "neither"
                                ? "First Name"
                                : "First Name"
                            }`}
                          value={firstName}
                          onChange={checkFirstName}
                        />
                      </div>
                      {firstNameError && (
                        <small className="text-danger">{firstNameError}</small>
                      )}
                    </Form.Group>
                    {accountType === "neither" && (
                      <Form.Group className="mb-4" controlId="lastName">
                        <Form.Label>Last Name </Form.Label>
                        <div className="position-relative custom-field">
                          <i className="bi bi-person-fill position-absolute start-0 h-100 pe-1 d-flex align-items-center fs-5"></i>
                          <Form.Control
                            className={lastNameError ? "error ps-4" : "ps-4"}
                            type="text"
                            placeholder="Enter your last name"
                            value={lastName}
                            onChange={checkLastName}
                          />
                        </div>
                        {lastNameError && (
                          <small className="text-danger">{lastNameError}</small>
                        )}
                      </Form.Group>
                    )}

                    <Form.Group className="mb-4" controlId="email">
                      <Form.Label>
                        {accountType === "brand" && "Brand/Organization Email"}
                        {accountType === "seller" && "Email"}
                        {accountType === "neither" && "Email"}
                        <span className="text-danger ms-1">*</span>
                      </Form.Label>
                      <div className="position-relative custom-field">
                        <i className="bi bi-envelope-fill position-absolute start-0 h-100 pe-1 d-flex align-items-center"></i>
                        <Form.Control
                          className={userEmailError ? "error ps-4" : "ps-4"}
                          type="email"
                          autoComplete="username"
                          placeholder={` ${accountType === "brand"
                            ? "Brand/Organization Email"
                            : accountType === "seller"
                              ? "This will be your login"
                              : accountType === "neither"
                                ? "Email"
                                : "Email"
                            }`}
                          value={userEmail}
                          onChange={checkEmail}
                          onKeyDown={(e) => {
                            if (e.key === " ") {
                              e.preventDefault();
                            }
                          }}
                        />
                      </div>
                      {userEmailError && (
                        <small className="text-danger">{userEmailError}</small>
                      )}
                    </Form.Group>

                    {sendOTP === true && (
                      <Form.Group className="mb-4" controlId="verifyOTP">
                        <Form.Label>
                          OTP <span className="text-danger ms-1">*</span>
                        </Form.Label>
                        <div className="position-relative custom-field">
                          <i className="bi bi-shield-fill position-absolute start-0 h-100 pe-1 d-flex align-items-center"></i>
                          <Form.Control
                            type="number"
                            placeholder="Enter Your 6 digit OTP"
                            className="ps-4"
                            value={otpValue}
                            onChange={checkOtp}
                            // onKeyPress={handleKeyDown}
                            onKeyDown={(event) => {
                              if (
                                ["e", ".", "+", "-"].includes(event.key) ||
                                event.key === "ArrowUp" ||
                                event.key === "ArrowDown"
                              ) {
                                event.preventDefault();
                              }
                            }}
                            onWheel={(e) => e.target.blur()}
                          />
                        </div>
                        {otpError && (
                          <small className="text-danger">{otpError}</small>
                        )}
                      </Form.Group>
                    )}

                    <Form.Group className="mb-4" controlId="newPassword">
                      <Form.Label>
                        Password <span className="text-danger ms-1">*</span>
                      </Form.Label>
                      <div className="position-relative custom-field">
                        <i className="bi bi-lock-fill position-absolute start-0 h-100 pe-1 d-flex align-items-center"></i>
                        <Form.Control
                          className={`ps-4 pe-5 ${(checkPasswordInCorrect || newPasswordError) ? 'error' : ''}`}
                          type={viewPass1 ? "text" : "password"}
                          placeholder={` ${accountType === "brand"
                            ? "Choose a strong password"
                            : accountType === "seller"
                              ? "Choose a strong password"
                              : accountType === "neither"
                                ? "Choose a strong password"
                                : "Choose a strong password"
                            }`}
                          value={newPassword}
                          onChange={checkNewPassword}
                          autoComplete="current-password"
                        />
                        <button
                          type="button"
                          className="btn border-0 position-absolute end-0 top-0 h-100 text-dark"
                          onClick={() => setViewPasss1(!viewPass1)}
                        >
                          {viewPass1 ? (
                            <i className="bi bi-eye-slash"></i>
                          ) : (
                            <i className="bi bi-eye"></i>
                          )}
                        </button>
                      </div>
                      {newPasswordError && (
                        <small className="text-danger">{newPasswordError}</small>
                      )}
                      {newPassword.length > 0 && (
                        <div className="d-flex justify-content-between align-items-center password-content-main pt-2">
                          <p className="mb-0">
                            Strength: <span className="text-capitalize fw-medium" style={{ color: strengthLevels[strength?.score]?.color }}>{strengthLevels[strength?.score]?.label || 'status'}</span>
                          </p>

                          <div className="d-flex align-items-center">
                            <div className={`tooltip-container ${isResized ? 'me-2' : ''}`}>
                              <div className="progress-container">
                                <div
                                  className="progress-bar"
                                  style={{
                                    transition: 'width 0.5s ease-in-out',
                                    width: strengthLevels[strength?.score]?.width || '0%',
                                    background: strengthLevels[strength?.score]?.background,
                                  }}
                                ></div>
                              </div>
                              <div
                                className={`custom-tooltip top tooltip-suggest ${passwordTyping ? 'active' : ''}`}
                              >
                                <div className="content">
                                  <h3>Your password must have</h3>
                                  <ul className="p-0 m-0">
                                    <li>{strength?.hasChar ? (<FaRegCircleCheck style={{ color: "green" }} />) : (<FaRegCircleXmark style={{ color: "red" }} />)}  At least 12 characters</li>
                                    <li>{strength?.hasUppercase && strength?.hasLowercase ? (<FaRegCircleCheck style={{ color: "green" }} />) : (<FaRegCircleXmark style={{ color: "red" }} />)} Upper and lowercase characters</li>
                                    <li>{strength?.hasNumber ? (<FaRegCircleCheck style={{ color: "green" }} />) : (<FaRegCircleXmark style={{ color: "red" }} />)} At least one number</li>
                                    <li>{strength?.hasSpecialChar ? (<FaRegCircleCheck style={{ color: "green" }} />) : (<FaRegCircleXmark style={{ color: "red" }} />)} At least one Special characters</li>
                                  </ul>
                                </div>
                                <span className="arrow"></span>
                              </div>
                            </div>
                            {isResized && (
                              <div className="tooltip-container">
                                {newPassword?.length > 0 && (
                                  <>
                                    {strength?.isLoading ? (
                                      <div className="position-relative" style={{
                                        width: "20px", height: "24px"
                                      }}>
                                        <i className={`bi bi-arrow-repeat spin`}></i>
                                      </div>
                                    ) : (
                                      <>
                                        <img src={!strength?.isPwned ? password_true : password_false} />
                                        <div className="custom-tooltip left h-auto">
                                          <div className="content">
                                            <div className="d-flex align-items-start justify-content-start gap-2">
                                              <div>
                                                {strength?.isPwned ? <GoAlert color="#DC3545" className="me-1 fs-6" /> : <IoCheckbox color="#099359" className="me-1 fs-6" />}
                                              </div>
                                              <p className="mb-0">
                                                {strength?.isPwned ? 'This password has appeared in known data breaches. Please choose a different one to keep your account secure.' : 'This password hasn’t been found in any known data breaches. Good choice!'}
                                              </p>
                                            </div>
                                          </div>
                                          <span className="arrow"></span>
                                        </div>
                                      </>
                                    )}
                                  </>
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                      {!isResized && newPassword && (
                        <div className={`d-flex align-items-center justify-content-start mt-2 ${strength?.isLoading ? "gap-2" : "gap-3"} pt-3 pb-3 px-3 strength-meter-box`}>
                          {strength?.isLoading ? (
                            <>
                              <div className="d-flex align-items-center justify-content-center">
                                <i className="bi bi-arrow-repeat spin position-relative top-0" style={{
                                  fontSize: "20px",
                                  left: 0
                                }}></i>
                              </div>
                              <p className="mb-0">Checking password security...</p>
                            </>
                          ) : (
                            <>
                              <div><img src={!strength?.isPwned ? password_true : password_false} width={'22px'} /></div>
                              <p className="mb-0"> {!strength?.isPwned ? 'This password hasn’t been found in any known data breaches. Good choice!' : 'This password has appeared in known data breaches. Please choose a different one to keep your account secure.'}</p>
                            </>
                          )}
                        </div>
                      )}

                    </Form.Group>

                    {accountType === "seller" && (
                      <>
                        <Form.Group
                          className="mb-4 d-none"
                          controlId="seller_ID"
                        >
                          <Form.Label>Seller ID (optional)</Form.Label>
                          <div className="position-relative custom-field">
                            <i className="bi bi-telephone-fill position-absolute start-0 h-100 pe-1 d-flex align-items-center"></i>
                            <Form.Control
                              className={
                                sellerCodeError ? "error ps-4" : "ps-4"
                              }
                              // className="ps-4"
                              type="text"
                              style={{ paddingRight: "80px" }}
                              placeholder="Enter your Seller ID"
                              value={sellercode}
                              onChange={checkSellerID}
                              disabled={sellerInterval ? true : false}
                            // onKeyPress={handleKeyDown}
                            />
                            {sellercode?.trim().length > 0 && (
                              <button
                                type="button"
                                className="btn btn-main2  px-3 py-1 position-absolute end-0 top-0 mt-1"
                                style={{ fontSize: "12px" }}
                                disabled={
                                  sellerCodeError ||
                                    sellerCodeLoader ||
                                    sellerInterval
                                    ? true
                                    : false
                                }
                                onClick={sellerverification}
                              >
                                {sellerInterval ? <Timer /> : "Verify"}
                                {/* Verify */}
                                {sellerCodeLoader && (
                                  <i className="fad fa-spinner fa-pulse fa-xs ms-1"></i>
                                )}
                              </button>
                            )}
                          </div>
                          {sellerCodeError && (
                            <small className="text-danger">
                              {sellerCodeError}
                            </small>
                          )}
                          {verifiedSeller && (
                            <small className="text-success">
                              {verifiedSeller}
                            </small>
                          )}
                        </Form.Group>
                      </>
                    )}
                    {accountType !== "neither" && (
                      <Form.Group
                        className="mb-4 d-none"
                        controlId="CompanyWebsite"
                      >
                        <Form.Label>
                          {accountType === "brand"
                            ? "Brand/org website(optional)"
                            : accountType === "seller"
                              ? "Business Website (optional)"
                              : "website(optional)"}
                        </Form.Label>
                        <div className="position-relative custom-field">
                          <i className="bi bi-globe-americas position-absolute start-0 h-100 pe-1 d-flex align-items-center"></i>
                          <Form.Control
                            className={
                              websiteError && website.trim().length > 0
                                ? "error ps-4"
                                : "ps-4"
                            }
                            type="text"
                            placeholder={`Enter your ${accountType === "brand"
                              ? "Brand/org website"
                              : accountType === "seller"
                                ? "Business Website"
                                : "website"
                              }`}
                            value={website}
                            onChange={checkWebsite}
                          />
                        </div>
                        {websiteError && website.trim().length > 0 && (
                          <small className="text-danger">{websiteError}</small>
                        )}
                      </Form.Group>
                    )}
                    <Form.Group className="mb-4" controlId="phone">
                      <Form.Label>Phone Number (optional)</Form.Label>
                      <div className="position-relative custom-field">
                        <i className="bi bi-telephone-fill position-absolute start-0 h-100 pe-1 d-flex align-items-center"></i>
                        <Form.Control
                          className={phoneError ? "error ps-4" : "ps-4"}
                          type="number"
                          placeholder="Enter your Phone Number"
                          value={phone}
                          onChange={checkPhone}
                          // onKeyPress={handleKeyDown}
                          onKeyDown={(event) => {
                            if (
                              ["e", ".", "+", "-"].includes(event.key) ||
                              event.key === "ArrowUp" ||
                              event.key === "ArrowDown"
                            ) {
                              event.preventDefault();
                            }
                          }}
                          onWheel={(e) => e.target.blur()}
                        />
                      </div>
                      {phoneError && (
                        <small className="text-danger">{phoneError}</small>
                      )}
                    </Form.Group>

                    <ReCAPTCHA
                      sitekey="6LeQVFYpAAAAABj2fVpd9l9gJnSkugoaRgqYONv0"
                      onChange={handleRecaptchaChange}
                      size="invisible"
                    />
                    {sendOTP ? (
                      <Button
                        className="btn-main2  w-100 mt-3"
                        variant="transparent"
                        type="submit"
                        onClick={OTPsubmit}
                        // onClick={() => window.grecaptcha.execute()}
                        disabled={signUpLoader ? true : false}
                      >
                        Continue
                        {signUpLoader && (
                          <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                            className="ms-2"
                          />
                        )}
                      </Button>
                    ) : (
                      <Button
                        className="btn-main2  w-100 mt-3"
                        variant="transparent"
                        type="submit"
                        onClick={handleSubmit}
                        // onClick={() => window.grecaptcha.execute()}
                        disabled={signUpLoader ? true : false}
                      >
                        Sign Up
                        {signUpLoader && (
                          <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                            className="ms-2"
                          />
                        )}
                      </Button>
                    )}
                  </>
                )}
              </Form>
            </div>
          </div>

          {/* <div className="col-lg-6 col-xl-7 col-xxl-7">
            {accountType.length > 0 ? (
              accountType === "brand" ? (
                <SignUpRightBrand />
              ) : accountType === "seller" ? (
                <SignUpRightSeller />
              ) : (
                <SignUpNeither />
              )
            ) : (
              <SignUpRight />
            )}
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default SignUpNew;
